export default import.meta.ROLLDOWN_FILE_URL_knmTGLZG1JipeE4uDCyNVw